import React from 'react';
import { PlusCircle } from 'lucide-react';
import type { Discipline } from './types';

interface NotOrderedViewProps {
  discipline: Discipline;
}

const NotOrderedView: React.FC<NotOrderedViewProps> = ({ discipline }) => {
  return (
    <div className="flex flex-col items-center justify-center py-10 text-center text-slate-400">
      <PlusCircle className="w-10 h-10 mb-3 text-slate-300" />
      <p className="text-sm font-medium text-slate-500">No referral accepted for {discipline}</p>
      <p className="text-xs mt-1">Accept a referral for {discipline} to begin onboarding</p>
    </div>
  );
};

export default NotOrderedView;
